import React, { ReactElement, useContext } from 'react';
import { AppContext } from '../../../../state/app.state';
import ViewLabel from './ViewLabel/ViewLabel';
import { ViewClientT } from 'bovaljaren-models';
import { useObserver } from 'mobx-react-lite';
import { isMobile } from '../../../../utils/app.helper';

type ViewLabelsProps={
};

const ViewLabels: React.FC<ViewLabelsProps> = ({ children }): ReactElement => {

    const { state } = useContext(AppContext);


    return useObserver(() => (
        <div className={'bv-view-labels'}>
            {state?.currentView?.statusPoints?.map(sP => {
                const view = state.project?.views.find(v => v.id === sP.mappingEntityId);

                return <ViewLabel key={sP.id}
                    statusPoint={sP} view={view}
                    previewing={
                        !!state.currentView?.mappings?.views?.find(vM => vM.mappingEntityId === sP.mappingEntityId &&
                            (state.isCurrentPreviewObject(vM.mappingEntityId) ||
                            state.isCurrentPreviewObject(vM.id) || view?.mappings.objects.find(({ mappingEntityId }) => state.isCurrentPreviewObject(mappingEntityId)))
                        )}/>;
            })}
        </div>
    ));
};


export default ViewLabels;